import React from 'react'

import { useNavigate } from '@lib/react-router-dom'

import { Body1, Heading6 } from '@ui/Typography'
import { PageSection } from '@ui/components/PageSection'

import { ScrollToIds, useScrollToElementIds } from '@hooks/useScrollToElementIds'

import styles from './SubscriptionsTradingPlatforms.module.scss'

export const SubscriptionsTradingPlatformsHelpPage: React.FC<{
  title: string
  description: string
}> = ({ title, description }) => {
  const navigate = useNavigate()

  const { scrollIntoView } = useScrollToElementIds()
  scrollIntoView([ScrollToIds.SubscriptionsTradingPlatformsHeader], {
    skipElementsViewportVisibility: true,
  })

  const handleGoBack = () => {
    navigate('/dashboard/subscriptions/trading-platforms')
  }

  return (
    <div>
      <PageSection
        title={title}
        onGoBack={handleGoBack}
        id={ScrollToIds.SubscriptionsTradingPlatformsHeader}
      />
      <div className={styles.content}>
        <Heading6 medium>{title}</Heading6>
        <div className='pt-3'>
          <Body1>{description}</Body1>
        </div>
      </div>
    </div>
  )
}
